/** @jsx jsx */
import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx, css, keyframes } from '@emotion/react';
import * as React from 'react';
import VisuallyHidden from '@reach/visually-hidden';
import { Text } from './Text';
import { useTheme } from './theme/Providers';
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var sizeStyles = {
  xs: css({
    width: '0.5rem',
    height: '0.5rem'
  }),
  sm: css({
    width: '0.75rem',
    height: '0.75rem'
  }),
  md: css({
    width: '1rem',
    height: '1rem'
  }),
  lg: css({
    width: '1.25rem',
    height: '1.25rem'
  }),
  xl: css({
    width: '1.5rem',
    height: '1.5rem'
  })
}; // spinner css based on one provided by bootstrap
// https://getbootstrap.com/docs/4.3/components/spinners/

export var Spinner = function Spinner(_a) {
  var _b = _a.delay,
      delay = _b === void 0 ? 400 : _b,
      _c = _a.size,
      size = _c === void 0 ? 'md' : _c,
      center = _a.center,
      label = _a.label,
      other = __rest(_a, ["delay", "size", "center", "label"]);

  var theme = useTheme();

  var _d = React.useState(delay === 0 ? true : false),
      show = _d[0],
      setShow = _d[1];

  React.useEffect(function () {
    var timer = setTimeout(function () {
      setShow(true);
    }, delay);
    return function () {
      clearTimeout(timer);
    };
  }, [delay]);
  return jsx("div", __assign({
    className: 'Spinner',
    css: [{
      opacity: show ? 1 : 0,
      display: 'inline-block',
      transition: 'opacity 0.4s cubic-bezier(0.35,0,0.25,1)'
    }, center && {
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'center',
      justifyContent: 'center'
    }]
  }, other), jsx("div", {
    className: 'Spinner__container',
    role: 'status',
    css: {
      color: theme.colors.text.default,
      textAlign: 'center',
      display: 'inline-block'
    }
  }, jsx("div", {
    className: 'Spinner__spinner',
    css: [css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              display: inline-block;\n              vertical-align: text-bottom;\n              border: 0.15em solid currentColor;\n              border-right-color: transparent;\n              border-radius: 50%;\n              animation: ", " 0.75s linear infinite;\n            "], ["\n              display: inline-block;\n              vertical-align: text-bottom;\n              border: 0.15em solid currentColor;\n              border-right-color: transparent;\n              border-radius: 50%;\n              animation: ", " 0.75s linear infinite;\n            "])), spin), sizeStyles[size]]
  }), label ? jsx(Text, {
    className: 'Spinner__label',
    wrap: false,
    css: {
      display: 'block',
      marginTop: theme.spaces.sm
    },
    variant: 'subtitle'
  }, label) : jsx(VisuallyHidden, null, 'Loading')));
};
var templateObject_1, templateObject_2;